// src/services/webhooks.js
import { WEBHOOKS } from "../constants/webhooks";
import { CATEGORIAS_WOO } from "../constants/categorias";
import { ETIQUETAS_WOO } from "../constants/etiquetas";

const withTimeout = (url, opts = {}, ms = 12000) => {
  const ctl = new AbortController();
  const id = setTimeout(() => ctl.abort(), ms);
  return fetch(url, { ...opts, signal: ctl.signal }).finally(() => clearTimeout(id));
};

// Sale price: enviar "" si es 0/vacío/NaN
const normalizeSalePrice = (valorRebajado) => {
  const num = Number(valorRebajado);
  if (!Number.isFinite(num) || num === 0) return "";
  return num;
};

// Etiqueta -> texto + id (o vacío/null)
const normalizeEtiqueta = (etiqueta) => {
  if (!etiqueta || etiqueta.trim() === "") {
    return { etiqueta: "", etiqueta_id: null };
  }
  return { etiqueta, etiqueta_id: ETIQUETAS_WOO[etiqueta] ?? null };
};

// Categoría -> texto + id
const normalizeCategoria = (categoria) => ({
  categoria,
  categoria_id: CATEGORIAS_WOO[categoria] ?? null,
});

// Payload común (incluye sucursalId y sucursalNombre)
const buildCommonPayload = (motoId, moto) => {
  const { etiqueta, etiqueta_id } = normalizeEtiqueta(moto.etiqueta);
  const { categoria, categoria_id } = normalizeCategoria(moto.categoria);

  const ano = moto.ano ?? moto.año ?? "";
  const financiamiento = moto.financiamiento || "No";
  const origen = moto.origen || "Nacional";

  // Campos de sucursal canónicos
  const sucursalId = moto.sucursalId || "";
  const sucursalNombre = moto.sucursalNombre || moto.sucursal || ""; // compat legacy

  return {
    moto_id: motoId,
    nombre: moto.nombre,
    codigoMoto: moto.codigoMoto || motoId,
    marca: moto.marca,
    modelo: moto.modelo,
    ano,
    color: moto.color,
    kilometros: moto.kilometros,
    cilindrada: moto.cilindrada,
    valor: moto.valor ?? 0,
    valorRebajado: normalizeSalePrice(moto.valorRebajado),
    financiamiento,
    origen,
    tipoMoto: moto.tipoMoto,
    categoria,
    categoria_id,
    // 🔴 Sucursal (canónico + legacy)
    sucursalId,
    sucursalNombre,
    sucursal: sucursalNombre, // legacy
    descripcion: moto.descripcion,
    estatus: moto.estatus,
    etiqueta,
    etiqueta_id,
    idProductFreshsales: moto.idProductFreshsales || moto.idFreshworks || null,
  };
};

// PUBLISH ALL (Webhook 1)
export const webhookPublishAll = async (motoId, moto, fotosArr = [], videoUrl = "") => {
  const url = WEBHOOKS.publish_all;
  if (!url) {
    console.warn("[webhookPublishAll] URL no configurada.");
    return;
  }
  const base = buildCommonPayload(motoId, moto);
  const media = {
    foto1: fotosArr[0] || "",
    foto2: fotosArr[1] || "",
    foto3: fotosArr[2] || "",
    foto4: fotosArr[3] || "",
    foto5: fotosArr[4] || "",
    foto6: fotosArr[5] || "",
    foto7: fotosArr[6] || "",
    Array_Fotos: fotosArr,
    video: videoUrl || "",
  };
  await withTimeout(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...base, ...media }),
  }).catch(() => {});
};

// UPDATE Woo + ML (Webhook 2)
export const webhookUpdateWcMl = async (motoId, moto, linkWoo = "", linkML = "") => {
  const url = WEBHOOKS.update_wc_ml;
  if (!url) {
    console.warn("[webhookUpdateWcMl] URL no configurada.");
    return;
  }
  const base = buildCommonPayload(motoId, moto);
  await withTimeout(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...base,
      link_wooCommerce: linkWoo || "",
      link_mercadoLibre: linkML || "",
    }),
  }).catch(() => {});
};

// INACTIVATE (Webhook 3)
export const webhookInactivateWcMl = async (motoId, moto, linkWoo = "", linkML = "") => {
  const url = WEBHOOKS.inactivate_wc_ml;
  if (!url) {
    console.warn("[webhookInactivateWcMl] URL no configurada.");
    return;
  }

  const idProductFreshsales = moto?.idProductFreshsales || moto?.idFreshworks || null;
  
  // Incluye sucursalId / sucursalNombre para trazabilidad
  const { sucursalId = "", sucursalNombre = "" } = moto || {};
  await withTimeout(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      nombre: moto.nombre,
      codigoMoto: moto.codigoMoto || motoId,
      estatus: moto.estatus,
      sucursalId,
      sucursalNombre,
      link_wooCommerce: linkWoo || "",
      link_mercadoLibre: linkML || "",
      idProductFreshsales,
    }),
  }).catch(() => {});
};